/* KKO³ — Ajout au panier sans quitter la page.
   Intercepte les formulaires d'ajout des sections maison, ajoute en arrière-plan,
   récupère le panier à jour, met à jour la pastille puis ouvre le panier latéral
   en lui transmettant le panier (même mécanique que kko-gift.js).
   En cas d'erreur réseau, le formulaire repart en soumission classique. */
(function () {
  var SELECTOR = 'form.kko-tab__form, form.kko-card__form, form[data-kko-ajax-cart]';

  function openDrawer(cart) {
    document.documentElement.dispatchEvent(new CustomEvent('wetheme-toggle-right-drawer', {
      detail: { type: 'cart', forceOpen: true, params: cart ? { cart: cart } : {} }
    }));
  }

  function updateBubble(cart) {
    var bubbles = document.querySelectorAll('.kko-hdr__cartcount');
    if (bubbles.length) {
      bubbles.forEach(function (b) { b.textContent = cart.item_count; });
    } else if (cart.item_count > 0) {
      document.querySelectorAll('.kko-hdr__icon.js-drawer-open-right-link, .kko-hdr__icon[aria-label="Panier"]').forEach(function (icon) {
        var s = document.createElement('span');
        s.className = 'kko-hdr__cartcount';
        s.textContent = cart.item_count;
        icon.appendChild(s);
      });
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest(SELECTOR) : null;
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) { return r.json().then(function (j) { throw j; }); }
        return r.json();
      })
      .then(function () {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (btn) { btn.textContent = '✓ Ajouté'; }
        updateBubble(cart);
        document.dispatchEvent(new CustomEvent('kko:cart:added', { detail: { cart: cart } }));
        openDrawer(cart);
        setTimeout(function () { if (btn) { btn.innerHTML = original; btn.disabled = false; } }, 1600);
      })
      .catch(function (err) {
        if (btn) { btn.innerHTML = original; btn.disabled = false; }
        if (err && err.description) { alert(err.description); }
        else { form.submit(); }
      });
  });
})();
